function imageSequnze() {

    function initCanvas(){
        
        const holder = document.querySelector(".canvas-container");
        const canvas = document.getElementById("canvas");
        const context = canvas.getContext("2d");

        const scrollHolder = document.querySelector('.scroll-holder');

        let lang = 'de';

        if (data['language']) {
            lang = data['language'];
        }


        
        const scStanztechnik        = document.querySelector('.sc-stanztechnik');
        const scOberfachentechnik   = document.querySelector('.sc-oberfachentechnik');
        const scAtztechnik          = document.querySelector('.sc-atztechnik');
        const scKunststofftechnik   = document.querySelector('.sc-kunststofftechnik');
        const scMontagetechnik      = document.querySelector('.sc-montagetechnik');
      
        canvas.width = 1920;
        canvas.height = 1080;

        //img.height = 1080;

        const frameCount = 107;
        const currentFrame = (index) =>
            `/wp-content/themes/possehlelectronics/img/sequenze_${lang}/sequenz_${(
                index
            )
                .toString()
                .padStart(3, "00")}.jpg`; 

            const images = []; 
            const frames = {
                frame: 0
            };

        for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
        images.push(img);
        }

        const masterTl = new gsap.timeline({paused:true});


        masterTl.to(scStanztechnik, {
            y:"-"+(holder.clientHeight+scStanztechnik.clientHeight+20), 
            duration: 2,
        });
        
        masterTl.to(frames, {
            frame: 27,
            snap: "frame",
            ease: "none", 
        });

        masterTl.to(scOberfachentechnik, {
            y:"-"+(holder.clientHeight+scOberfachentechnik.clientHeight+20), 
            duration: 2,
        });

        masterTl.to(frames, {
            frame: 54, 
            snap: "frame",
            ease: "none",
        });

        masterTl.to(scAtztechnik, {
            y:"-"+(holder.clientHeight+scAtztechnik.clientHeight+20), 
            duration: 2,
        });

        masterTl.to(frames, {
            frame: 80, 
            snap: "frame",
            ease: "none",
        });

        masterTl.to(scKunststofftechnik, {
            y:"-"+(holder.clientHeight+scKunststofftechnik.clientHeight+20), 
            duration: 2,
        });

        masterTl.to(frames, {
            frame: 106, 
            snap: "frame",
            ease: "none",
        });

        masterTl.to(scMontagetechnik, {
            y:"-"+(holder.clientHeight+scMontagetechnik.clientHeight+20), 
            duration: 2,
        });


      

     
        console.log( (visibleWindowHeight() - canvas.clientHeight)/2);
       

        const configMasterTl = {
           
            trigger: ".canvas-container",
            start:  "top "+(visibleWindowHeight() - canvas.clientHeight)/2,
            end: "+=1000%",
            animation: masterTl,
            onUpdate: render,
            pin: true,
            scrub: 0.7,
            anticipatePin: 1
 
        }
        ScrollTrigger.create(configMasterTl);

      

        images[0].onload = render;

        function render() {
            var factor  = Math.min ( canvas.width / 1920, canvas.height / 1080 );
            context.scale(factor, factor);
            context.clearRect(0, 0, factor, factor);
            context.drawImage(images[frames.frame], 0, 0);
            context.scale(1 / factor, 1 / factor);
        }
    }

    


        
    function resizeCanvas() {
        if (!isMobile) {
            initCanvas();
        }

    }
    window.addEventListener('resize', resizeCanvas, false);

    if (!isMobile) {
        initCanvas();
    }


}